export default "__VITE_ASSET__BGwR9A3k__"